import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import ConsoleLayout from '@/components/layout/ConsoleLayout';
import { useTenant } from '@/hooks/useTenant';

interface AppShellProps {
  activeView: string;
  children: ReactNode;
}

// Wraps a standalone route (Integrations, Settings, Signals — pages that
// live outside Index.tsx's in-page view switch) with the same console chrome
// the main shell uses, so navigating to one of these pages doesn't strand the
// user without app-wide navigation.
const AppShell = ({ activeView, children }: AppShellProps) => {
  const navigate = useNavigate();
  const { tenantSlug } = useTenant();

  // Sidebar sections map to views inside Index.tsx's renderContent() switch, so
  // selecting one from a standalone route navigates back into the app shell via
  // the `?view=` deep link (the default view omits the param).
  const handleViewChange = (view: string) => {
    if (!tenantSlug) return navigate('/');
    navigate(view === 'dashboard' ? `/${tenantSlug}/app` : `/${tenantSlug}/app?view=${view}`);
  };

  return (
    <ConsoleLayout activeView={activeView} onViewChange={handleViewChange}>
      {children}
    </ConsoleLayout>
  );
};

export default AppShell;
